import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Silence developer logging in production builds.
//
// The app carries ~60 console.log calls used while developing, several of
// which dump whole API objects (resolved booking links, navigation history,
// raw error responses) into the console of every customer's browser.
//
// Suppressing centrally rather than deleting each call keeps the logging
// available during development, where it is genuinely useful, and means a
// newly added console.log can never leak to production by being forgotten.
//
// warn and error are deliberately left alone: they carry real diagnostics for
// support, and browser extensions and Stripe use them too.
if (environment.production) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.trace = noop;
  console.table = noop;
  console.dir = noop;
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
